module.exports = __webpack_public_path__ + "static/media/downloadOn_appStore.065e4193.png";